import { FC } from "react";
import { motion } from "framer-motion";
import SideBar from "../components/dashboard/SideBar";
import DashboardHeader from "../components/dashboard/header/DashboardHeader";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import { activeSideBarSelector, dashboardSelector } from "@/store/features/dashboardSlice";
import BreadcrumbComponent from "@/components/dashboard/Breadcrumb";

interface Props {
  className?: string;
  children: React.ReactNode;
}

const selectSideBarData = createSelector(
  (state: RootState) => state.dashboard.sideBars,
  (state: RootState) => state.dashboard.activeSideBarKey,
  (sideBars, activeSideBarKey) => ({ sideBars, activeSideBarKey })
);

const PaymentHistoryTableLayout: FC<Props> = ({ children, className = "" }) => {
  const { sideBars, activeSideBarKey } = useSelector(selectSideBarData);
  const { routeSegments, isSideBarExpanded } = useSelector(dashboardSelector);
  const currentPath = `/${routeSegments.join("/")}`;
  const activeSideBar = useSelector(activeSideBarSelector);
  const showBreadCrumb = !activeSideBar?.hideBreadCrumb;
  const isSideBarHidden = activeSideBar?.skipContentSideBar?.includes(currentPath);

  // Responsive width logic
  const mainContentWidth = isSideBarExpanded ? "w-full md:w-[calc(100%-200px)]" : "w-full md:w-[calc(100%-48px)]";
  const containerClass = ["flex pt-12 md:pt-0 flex-col", mainContentWidth, className].join(" ");

  return (
    <motion.div className="w-full min-h-screen md:h-screen flex flex-col md:flex-row overflow-hidden">
      <SideBar sideBars={sideBars} activeSideBarKey={activeSideBarKey} />
      <div className={containerClass}>
        <DashboardHeader />
        {showBreadCrumb && <BreadcrumbComponent />}
        <div
          className={`${
            showBreadCrumb 
              ? "w-full px-2 sm:px-3 md:px-4" 
              : isSideBarHidden 
                ? "w-full md:w-[calc(100%-200px)]" 
                : "w-full md:w-full"
          } bg-containerBg flex-1 flex h-[calc(100%-112px)]`}
        >
          <main className="sm:pt-2 bg-white rounded-llg h-[calc(100%-16px)] w-full overflow-hidden overflow-x-auto">{children}</main>
        </div>
      </div>
    </motion.div>
  );
};

export default PaymentHistoryTableLayout;
